// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-inspector-timings {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
}
.chartkit-inspector-timings__metric {
  color: var(--g-color-text-primary);
}
.chartkit-inspector-timings__metric_warning {
  color: var(--g-color-text-warning);
}
.chartkit-inspector-timings__metric.chartkit-inspector-timings__metric_danger {
  color: var(--g-color-text-danger);
}
.chartkit-inspector-timings__metric-value {
  font-size: var(--g-text-header-1-font-size);
  line-height: var(--g-text-header-1-line-height);
  font-weight: 500;
  margin-bottom: 4px;
}
.chartkit-inspector-timings__metric-title {
  color: var(--g-color-text-secondary);
  display: flex;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/Menu/Items/Inspector/Timings/Timings.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2DAAA;AACJ;AACI;EACI,kCAAA;AACR;AACQ;EACI,kCAAA;AACZ;AAEQ;EACI,iCAAA;AAAZ;AAII;EACI,2CAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAKI;EACI,oCAAA;EACA,aAAA;EACA,QAAA;AAHR","sourcesContent":[".chartkit-inspector-timings {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));\n}\n.chartkit-inspector-timings__metric {\n  color: var(--g-color-text-primary);\n}\n.chartkit-inspector-timings__metric_warning {\n  color: var(--g-color-text-warning);\n}\n.chartkit-inspector-timings__metric.chartkit-inspector-timings__metric_danger {\n  color: var(--g-color-text-danger);\n}\n.chartkit-inspector-timings__metric-value {\n  font-size: var(--g-text-header-1-font-size);\n  line-height: var(--g-text-header-1-line-height);\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n.chartkit-inspector-timings__metric-title {\n  color: var(--g-color-text-secondary);\n  display: flex;\n  gap: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
